(() => {
  if (window.KiiveReviewNameDisplay) return;
  const anonymous = document.currentScript?.dataset.anonymous || 'Anonymous';
  const names = '.jdgm-widget .jdgm-rev__author, .jdgm-widget .jdgm-carousel-item__reviewer-name, .jm-reviewer-info .jm-reviewer-info__name';
  const emailLike = value => /[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+/u.test(
    String(value || '').replace(/&#(?:0*64|x0*40);|&commat;/gi, '@').replace(/[\u200B-\u200D\u2060\uFEFF]/gu, '')
  );
  function mask(node) {
    if (!node.matches(names)) return;
    const values = [node.textContent, node.getAttribute('title'), node.getAttribute('aria-label')];
    if (values.some(emailLike)) {
      if (node.textContent !== anonymous) node.textContent = anonymous;
      for (const element of [node, ...node.querySelectorAll('[title], [aria-label], a[href]')]) {
        for (const attr of ['title', 'aria-label']) {
          if (emailLike(element.getAttribute(attr))) element.setAttribute(attr, anonymous);
        }
        if (/^mailto:/i.test(element.getAttribute('href') || '')) element.removeAttribute('href');
      }
      const reviewer = node.closest('.jm-reviewer-info');
      if (reviewer) {
        const initial = reviewer.querySelector('.jm-reviewer-avatar__initial .jm-text');
        if (initial && initial.textContent !== anonymous.slice(0, 1)) initial.textContent = anonymous.slice(0, 1);
        for (const element of reviewer.querySelectorAll('.jm-reviewer-avatar [title], .jm-reviewer-avatar [aria-label], .jm-reviewer-avatar img[alt]')) {
          for (const attr of ['title', 'aria-label', 'alt']) {
            if (emailLike(element.getAttribute(attr))) element.setAttribute(attr, anonymous);
          }
        }
      }
    }
    if (!node.hasAttribute('data-kiive-name-checked')) node.setAttribute('data-kiive-name-checked', '');
  }
  function scan(scope) {
    if (scope.nodeType !== 1 && scope.nodeType !== 9) return;
    if (scope.matches?.(names)) mask(scope);
    scope.querySelectorAll(names).forEach(mask);
  }
  const observer = new MutationObserver(records => {
    const pending = new Set();
    for (const record of records) {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      const name = element?.closest(names);
      if (name) pending.add(name);
      if (record.type === 'attributes' && record.attributeName === 'class') pending.add(element);
      for (const node of record.addedNodes || []) {
        if (node.nodeType === 1) pending.add(node);
      }
    }
    for (const node of pending) if (node?.isConnected) scan(node);
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'title', 'aria-label', 'href']
  });
  window.KiiveReviewNameDisplay = { scan };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
